import React from 'react';
import { Modal } from 'panamera-react-ui';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import css from './AlreadyExistModal.scss';
import IconWrapper from 'Components/IconWrapper/IconWrapper';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';

const AlreadyExistModal = ({ onCloseBookingModal, intl }) => {
    return (
        <Modal
            className={ css.bookingModal }
            icon=""
        >
            <div className={ css.bookingModalWrapper }>
                <div className={ css.bookingModalHeadingWrapper }>
                    <IconWrapper
                        className={ css.crossIcon }
                        icon={ 'cross' }
                        size={ 20 }
                        onClick={ onCloseBookingModal }
                        dataAutId="close-booking-modal"
                    />
                </div>
                <ImageWrapper
                    className={ css.sendImage }
                    src="https://statics.olx.co.id/olxid/escrow/send.png"
                />
                <div className={ css.titleSubtitleWrapper }>
                    <span className={ css.alreadyExistDetailTitle }>
                        {intl.formatMessage({
                            id: 'alreadyExistDetailTitle',
                            defaultMessage: 'Permintaan Booking sudah di ajukan'
                        })}
                    </span>
                    <span className={ css.alreadyExistDetailSubtitle }>
                        {intl.formatMessage({
                            id: 'alreadyExistDetailSubtitle',
                            defaultMessage: 'Penjual sudah menerima permintaan Anda untuk segera mengaktifkan Fitur Booking'
                        })}
                    </span>
                </div>
            </div>
        </Modal>);
};

AlreadyExistModal.propTypes = {
    onCloseBookingModal: PropTypes.func,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    })
};

AlreadyExistModal.defaultProps = {
    onCloseBookingModal: () => { }
};

export default compose(
    injectIntl
)(AlreadyExistModal);
